import en from "@/locales/en.js";

/* Dict is a dictionary of translations. This function adds all the fields which
 * are not defined from the default language dictionary (en in this case). This
 * function works destructively, and returns the result. */
function inject_defaults(dict) {
    for (const prop in en)
        if (!dict.hasOwnProperty(prop))
            dict[prop] = en[prop];
    return dict;
}

export default inject_defaults;
